// extracted by mini-css-extract-plugin
export var bottomRightDock = "_16-0";